var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttendanceApprovalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 54,
    viewBox: "0 0 53 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4318_11)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 27,
    rx: 26.5,
    ry: 27,
    fill: "white"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5,
    cy: 27,
    rx: 25.5,
    ry: 26,
    fill: "#F3F8FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 17.2391V37.0235C16 37.3983 16.1497 37.7578 16.4162 38.0228C16.6828 38.2878 17.0442 38.4367 17.4212 38.4367H21.6847V35.6104H18.8423V18.6523H21.6847V15.826H17.4212C17.0442 15.826 16.6828 15.9748 16.4162 16.2399C16.1497 16.5049 16 16.8643 16 17.2391ZM36.2402 15.8684L24.8709 13.042C24.6615 12.9901 24.4428 12.9862 24.2317 13.0308C24.0205 13.0754 23.8224 13.1673 23.6522 13.2994C23.4821 13.4315 23.3445 13.6005 23.2498 13.7934C23.1551 13.9863 23.1059 14.1981 23.1058 14.4128V39.8499C23.1053 40.0647 23.1542 40.2768 23.2487 40.47C23.3432 40.6632 23.4809 40.8324 23.6511 40.9646C23.8214 41.0969 24.0198 41.1887 24.2312 41.2331C24.4426 41.2774 24.6614 41.2732 24.8709 41.2207L36.2402 38.3943C36.5478 38.318 36.8209 38.1417 37.0161 37.8933C37.2113 37.6449 37.3174 37.3388 37.3175 37.0235V17.2391C37.3174 16.9239 37.2113 16.6178 37.0161 16.3694C36.8209 16.121 36.5478 15.9446 36.2402 15.8684ZM30.2116 27.397C30.1953 27.7609 30.0384 28.1044 29.7737 28.3562C29.5089 28.6079 29.1568 28.7484 28.7905 28.7484C28.4242 28.7484 28.072 28.6079 27.8073 28.3562C27.5426 28.1044 27.3857 27.7609 27.3693 27.397V26.8642C27.3695 26.4894 27.5194 26.1301 27.7861 25.8652C28.0527 25.6003 28.4143 25.4516 28.7912 25.4518C29.1681 25.452 29.5295 25.601 29.7959 25.8662C30.0623 26.1313 30.2118 26.4909 30.2116 26.8657V27.397Z",
    fill: "#4297FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4318_11"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 54,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceApprovalIcon);
export default __webpack_public_path__ + "static/media/attendanceApprovalIcon.fc6217a6127911dab716850e05199b9c.svg";
export { ForwardRef as ReactComponent };